import { call, put } from '@redux-saga/core/effects';
import { api, notify } from 'services';
import {
  FetchEmbedZohoActions as Actions,
  FetchEmbedZohoRequestAction as RequestAction,
} from 'store/ducks/zohoDashboard/getZohoEmbedUrl';

export function* fetchZohoEmbedUrlRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;  
  try {
    const { data } = yield call(api.get, `zoho-embed/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const errorMessage = 'Ocorreu um erro ao buscar o link de incorporação do Zoho.';
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
